import type { UserStatus } from '../types';

import styles from './user-status-chip.module.scss';

const LABEL: Record<UserStatus, string> = {
  active: 'Active',
  inactive: 'Inactive',
  pending_activation: 'Activation Pending',
};

/** 3-state pill: green Active / red Inactive / amber Activation Pending (Figma 577-30813, 765:281917).
 *  Mirrors `PaymentStatusChip` — the shared `<Chip>` intents are stage labels, not account states. */
export function UserStatusChip({ status }: { status: UserStatus }) {
  return <span className={[styles.chip, styles[status]].join(' ')}>{LABEL[status]}</span>;
}
